import { Box, EntityMultiSelect, Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import useBulkCreateAgencyOrderBundles from '../../hooks/useBulkCreateAgencyOrderBundles'

type SelectAgenciesProps = {
  bulkCreateAgencyOrderBundlesPayload: ReturnType<typeof useBulkCreateAgencyOrderBundles>,
}

const SelectAgencies = (props: SelectAgenciesProps) => {
  const { bulkCreateAgencyOrderBundlesPayload } = props
  const {
    agencies,
    callbacks: {
      loadMore,
      setSelectedEntityIds,
    },
    canLoadMore,
    filteredAgenciesCount,
    filteredAgencyIds,
    filteredBrandGroups,
    hasActiveFilters,
    loadingAgencies,
    searchForm,
    selectedEntityIds,
  } = bulkCreateAgencyOrderBundlesPayload

  const {
    entityState: {
      brand_id, brand_group_id, string,
    },
    setEntityState: setSearchState,
    handlers,
  } = searchForm

  return (
    <Box flexDirection="column">
      <EntitySelector
        callbacks={{
          selectItem: brand => setSearchState({
            brand_id: brand ? brand.id : null,
            brand_group_id: '',
            string: '',
          }),
        }}
        entityKey="brands"
        label="Brand"
        requestOptions={{
          include_brand_brand_groups: true,
        }}
        searchRequestOptions={brand_group_id}
        selectedItemId={brand_id}
      />

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Brand Administrator', 'Support']}>
        <Form.Field label="Brand Group" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <select
            disabled={!brand_id}
            name="brand_group_id"
            value={brand_group_id}
            {...handlers}
          >
            <option value="">{brand_id ? 'Select Brand Group' : 'Please Select Brand'}</option>
            {filteredBrandGroups.map(brandGroup => (
              <option key={brandGroup.id} value={brandGroup.id}>
                {brandGroup.title}
              </option>
            ))}
          </select>
        </Form.Field>
      </ScopedConditionalContent>

      <Form.Field label="Agency Title" marginTop="large">
        <input
          disabled={!brand_id}
          name="string"
          type="text"
          value={string}
          {...handlers}
        />
      </Form.Field>

      {(brand_id || !!selectedEntityIds.length) && (
        // @ts-expect-error TS2741
        <EntityMultiSelect
          filteredEntityIds={hasActiveFilters ? filteredAgencyIds : []}
          boxProps={{ marginTop: 'large' }}
          callbacks={{
            loadMore,
            setSelectedIds: setSelectedEntityIds,
          }}
          canLoadMore={canLoadMore}
          entities={agencies}
          entityCount={filteredAgenciesCount}
          loading={loadingAgencies}
          selectedIds={selectedEntityIds}
        />
      )}
    </Box>
  )
}

export default SelectAgencies
